import { render, staticRenderFns } from "./TopClientes.vue?vue&type=template&id=a9362ade"
import script from "./TopClientes.vue?vue&type=script&lang=js"
export * from "./TopClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports